import { h } from 'preact';
import { useState, useRef } from 'preact/hooks';

export const BUTTON_SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
};

export const BUTTON_SCHEMES = {
  PRIMARY: 'PRIMARY',
  WHITE: 'WHITE',
  OUTLINE: 'OUTLINE',
};

const BUTTON_SIZE_CLASSES = {
  [BUTTON_SIZES.SMALL]: 'cirk-button-sm',
  [BUTTON_SIZES.MEDIUM]: 'cirk-button',
  [BUTTON_SIZES.LARGE]: 'cirk-button-lg',
};

const BUTTON_SCHEME_CLASSES = {
  [BUTTON_SCHEMES.PRIMARY]: 'cirk-button-primary',
  [BUTTON_SCHEMES.WHITE]: 'cirk-button-white',
  [BUTTON_SCHEMES.OUTLINE]: 'cirk-button-outline',
};

export function Button({ 
  type = 'button', 
  size = BUTTON_SIZES.MEDIUM,
  scheme = BUTTON_SCHEMES.PRIMARY,
  fullWidth = false,
  disabled = false,
  classNames = '',
  children, 
  onClick,
  isBubbly = false,
  dataUxTrackClick,
}) {
  const disabledStyles = disabled ? 'tw-pointer-events-none' : '';
  const widthClasses = fullWidth ? 'tw-w-full' : '';
  const buttonRef = useRef(null);
  const [particles, setParticles] = useState([]);

  const generateBubbles = () => {
    const buttonWidth = buttonRef.current.offsetWidth;
    const bubbleCount = Math.floor(buttonWidth / 50) * 10;
    const particlesArray = [];
    for (let i = 0; i < bubbleCount; i++) {
      const size = (Math.random() * 40 + 40) / 10;
      const left = Math.random() * buttonWidth;
      const delay = (Math.random() * 5) / 10;
      particlesArray.push({
        size,
        left,
        delay,
      });
    }
    setParticles(particlesArray);
  };

  const handleMouseEnter = () => {
    if (isBubbly) {
      generateBubbles();
    }
  };

  const handleMouseLeave = () => {
    setParticles([]);
  };

  const bubbleClasses = isBubbly ? 'tw-relative tw-group' : '';

  // Build full class list
  const allClasses = `${BUTTON_SIZE_CLASSES[size] || ''} ${BUTTON_SCHEME_CLASSES[scheme] || ''} ${disabledStyles} ${widthClasses} ${classNames} ${bubbleClasses}`;

  return (
    <button
      type={type}
      className={allClasses}
      onClick={onClick}
      disabled={disabled}
      ref={buttonRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...(dataUxTrackClick ? { 'data-ux-track-click': dataUxTrackClick } : {})}
    >
      {children}
      {isBubbly && (
        <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-right-auto tw-w-full">
          <div className="tw-relative tw-size-full">
            {particles.map((particle, index) => (
              <span
                key={index}
                className={`tw-absolute tw-rounded-full ${
                  scheme === BUTTON_SCHEMES.WHITE ? 'tw-bg-white' : 'tw-bg-blue-500'
                } tw-opacity-0 group-hover:tw-animate-bubbles`}
                style={{
                  top: `48px`,
                  left: `${particle.left}px`,
                  width: `${particle.size}px`,
                  height: `${particle.size}px`,
                  animationDelay: `${particle.delay}s`,
                }}
              ></span>
            ))}
          </div>
        </div>
      )}
    </button>
  );
}
